<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block color="primary" dark v-bind="attrs" v-on="on">
        Change Password
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Change Password</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                  v-model="old_password"
                  label="Old Password"
                  type="password"
                  :rules="requiredRules"
                  required
                />
                <v-text-field
                  v-model="new_password"
                  label="New Password"
                  type="password"
                  :rules="requiredRules"
                  required
                />
                <v-text-field
                  v-model="new_password_confirm"
                  label="Re-Enter New Password"
                  type="password"
                  :rules="pwdConfirmRules"
                  required
                />
                <div class="justify-center">
                  <h3 class="mb-3">
                    Generated password: {{ generatePassword }}
                  </h3>
                  <v-btn class="success" small @click="generateRandomPassword">
                    Generate Password
                  </v-btn>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn
          color="blue darken-1"
          :disabled="!valid"
          text
          @click="updatePassword"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewPasswordForm",
  props: {
    user_id: Number,
  },
  data() {
    return {
      open: false,
      old_password: "",
      new_password: "",
      new_password_confirm: "",
      generatePassword: "",
      lazy: false,
      valid: false,
      requiredRules: [(value) => !!value || "Required."],
      emailRules: [
        (value) => !!value || "Required.",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Invalid Email address",
      ],
      pwdConfirmRules: [
        (value) => !!value || "Required.",
        (value) => value === this.new_password || "Password must be the same",
      ],
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    generateRandomPassword() {
      this.generatePassword = Math.random().toString(36).substr(2, 12);
      this.new_password = this.generatePassword;
      this.new_password_confirm = this.generatePassword;
    },

    updatePassword() {
      const password_obj = {
        old_password: this.old_password,
        new_password: this.new_password,
      };

      this.$axios
        .put(`/agents/password/${this.user_id}`, password_obj)
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((e) => {
          console.error(e);
          this.showHandlerSnackbar({
            color: e.response.data.status,
            text: e.response.data.message,
            show: true,
          });
        });
    },
  },
};
</script>